import { FileAttachmentRecord, FileAttachmentRequestBody } from './types';

export const constructFormData = (
  file: File,
  reqBody: FileAttachmentRecord & { attachment?: Record<string, number> },
): FormData => {
  const formData = new FormData();
  const fileMeta: FileAttachmentRequestBody = {
    ...reqBody,
    attachment: {
      name: file?.name,
      // TODO: Work attachments privacy once we've a solution for email attachments.
      publicVisibility: true,
      ...reqBody.attachment,
    },
  };

  const json = JSON.stringify(fileMeta);
  const blob = new Blob([json], {
    type: 'application/json',
  });

  formData.append('file', file);
  formData.append('request', blob);

  return formData;
};
